module.exports = __webpack_public_path__ + "img/configH5Video.1766306608134.jpg";